var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourtSelling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.854,
    height: 94.695,
    viewBox: "0 0 84.854 94.695",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10764",
    "data-name": "Group 10764",
    transform: "translate(-1506.676 -1193.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10696",
    "data-name": "Group 10696",
    transform: "translate(138.676 88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_contract_-_Flaticon-2",
    "data-name": "Search results for House contract - Flaticon-2",
    transform: "translate(1309.05 1105.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10518",
    "data-name": "Group 10518",
    transform: "translate(66.951 40.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10517",
    "data-name": "Group 10517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M158.2,229.53H107.352a1.3,1.3,0,1,0,0,2.59H158.2a1.3,1.3,0,0,0,0-2.59Z",
    transform: "translate(-105.939 -229.525)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10520",
    "data-name": "Group 10520",
    transform: "translate(67.95 54.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10519",
    "data-name": "Group 10519",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M156.308,304.72H108.733a3.755,3.755,0,0,0-2.412.612.8.8,0,0,0,0,1.365,3.755,3.755,0,0,0,2.412.612h47.575c1.326-.059,2.344-.621,2.344-1.3S157.635,304.779,156.308,304.72Z",
    transform: "translate(-105.939 -304.715)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522",
    transform: "translate(66.95 80.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129",
    "data-name": "Path 10129",
    d: "M157.246,455.1H108.151c-1.123.059-1.985.621-1.985,1.295s.861,1.236,1.985,1.295h49.093c1.123-.059,1.985-.621,1.985-1.295s-.861-1.236-1.985-1.3Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10522-2",
    "data-name": "Group 10522",
    transform: "translate(66.95 67.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521-2",
    "data-name": "Group 10521",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10129-2",
    "data-name": "Path 10129",
    d: "M157.246,455.1H108.151c-1.123.059-1.985.621-1.985,1.295s.861,1.236,1.985,1.295h49.093c1.123-.059,1.985-.621,1.985-1.295s-.861-1.236-1.985-1.3Z",
    transform: "translate(-106.167 -455.1)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524",
    transform: "translate(66.931 7.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10523",
    "data-name": "Group 10523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10130",
    "data-name": "Path 10130",
    d: "M128.2,55.2,117.369,45.029a1.3,1.3,0,0,0-1.773,0L104.766,55.2a1.3,1.3,0,1,0,1.773,1.888l9.943-9.34,9.943,9.34A1.3,1.3,0,1,0,128.2,55.2Z",
    transform: "translate(-104.269 -44.68)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10526",
    "data-name": "Group 10526",
    transform: "translate(70.366 13.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10525",
    "data-name": "Group 10525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    "data-name": "Path 10131",
    d: "M140.1,81.8l-6.629-6.227a2.145,2.145,0,0,0-2.932,0L123.91,81.8a2.148,2.148,0,0,0-.676,1.561v9.058a2.143,2.143,0,0,0,2.141,2.141h13.258a2.143,2.143,0,0,0,2.141-2.141v-9.06A2.149,2.149,0,0,0,140.1,81.8Zm-7.145,10.17h-1.9V87.48h1.9Zm5.23,0h-2.64V86.66a1.772,1.772,0,0,0-1.77-1.77h-3.541a1.771,1.771,0,0,0-1.769,1.77v5.31h-2.64V83.553h0L132,77.748l6.18,5.805Z",
    transform: "translate(-123.234 -74.994)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10528",
    "data-name": "Group 10528",
    transform: "translate(58.95 0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10527",
    "data-name": "Group 10527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    "data-name": "Path 10132",
    d: "M127.661,36.512a1.293,1.293,0,0,0-1.3,1.286V87.352a.1.1,0,0,1-.1.1H61.638a.1.1,0,0,1-.1-.1V2.661a.1.1,0,0,1,.1-.1H105.7V20.309a2.724,2.724,0,0,0,2.735,2.707h17.928v6.726a1.3,1.3,0,0,0,2.589,0v-8.1a1.272,1.272,0,0,0-.02-.162h0a1.266,1.266,0,0,0-.044-.159.117.117,0,0,0-.014-.04,1.271,1.271,0,0,0-.065-.145V21.13a1.287,1.287,0,0,0-.09-.141l-.025-.034a1.273,1.273,0,0,0-.113-.13L107.908.375a1.279,1.279,0,0,0-.131-.111l-.035-.026A1.315,1.315,0,0,0,107.6.15h-.009a1.3,1.3,0,0,0-.145-.063l-.041-.015a1.3,1.3,0,0,0-.16-.044h-.006a1.325,1.325,0,0,0-.159-.02H61.638A2.678,2.678,0,0,0,58.95,2.67V87.348a2.678,2.678,0,0,0,2.688,2.661h64.623a2.678,2.678,0,0,0,2.688-2.661V37.794a1.293,1.293,0,0,0-1.289-1.282ZM108.288,4.374l16.249,16.081h-16.1a.146.146,0,0,1-.146-.144Z",
    transform: "translate(-58.95 -0.009)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10695",
    "data-name": "Group 10695",
    transform: "translate(1390.19 1138.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.332,
    cy: 31.331,
    rx: 31.332,
    ry: 31.331,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.332,
    cy: 31.331,
    rx: 30.832,
    ry: 30.831,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676",
    transform: "translate(12.201 36.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M20.1,396.412a2.779,2.779,0,0,0-2.239-4.425H4.366a2.777,2.777,0,0,0-2.238,4.424A3.972,3.972,0,0,0,0,399.926v.794a.794.794,0,0,0,.794.794H21.435a.794.794,0,0,0,.794-.794v-.794A3.972,3.972,0,0,0,20.1,396.412ZM3.524,393.923a1.183,1.183,0,0,1,.842-.349h13.5a1.191,1.191,0,1,1,0,2.382H4.366a1.191,1.191,0,0,1-.842-2.033Zm-1.936,6a2.385,2.385,0,0,1,2.382-2.382H18.26a2.385,2.385,0,0,1,2.382,2.382Z",
    transform: "translate(0.296 -391.691)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108_-_Outline",
    "data-name": "Path 10108 - Outline",
    d: "M4.412,391.737h13.5a3.076,3.076,0,0,1,2.659,4.621,4.256,4.256,0,0,1,2,3.614v.794a1.091,1.091,0,0,1-1.09,1.09H.84a1.091,1.091,0,0,1-1.09-1.09v-.794a4.256,4.256,0,0,1,2.005-3.615,3.073,3.073,0,0,1,2.657-4.62Zm17.069,9.527a.5.5,0,0,0,.5-.5v-.794a3.669,3.669,0,0,0-1.969-3.253l-.3-.16.2-.277a2.458,2.458,0,0,0,.481-1.471,2.486,2.486,0,0,0-2.483-2.483H4.412a2.481,2.481,0,0,0-2,3.953l.2.277-.3.16a3.669,3.669,0,0,0-1.971,3.253v.794a.5.5,0,0,0,.5.5ZM4.412,393.325h13.5a1.486,1.486,0,1,1,0,2.973H4.412a1.486,1.486,0,1,1,0-2.973Zm13.5,2.382a.9.9,0,1,0,0-1.79H4.412a.9.9,0,1,0,0,1.79ZM4.015,397.294h14.29a2.68,2.68,0,0,1,2.677,2.677v.3H1.338v-.3A2.68,2.68,0,0,1,4.015,397.294Zm16.356,2.382a2.089,2.089,0,0,0-2.065-1.79H4.015a2.089,2.089,0,0,0-2.065,1.79Z",
    transform: "translate(0.25 -391.737)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677",
    transform: "translate(12.202 7.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M38.966,32.55a4.878,4.878,0,0,0-.933-1.072l-3.62-3.157a.769.769,0,0,0-.308-.269l-2.189-1.909L21.782,17.3a2.32,2.32,0,0,0-.68-3.7l.937-.937a3.1,3.1,0,0,0,2.992-.8,3.1,3.1,0,0,0,0-4.383L18.457.909A3.1,3.1,0,0,0,13.274,3.9L3.92,13.254a3.118,3.118,0,0,0-.8-.1,3.1,3.1,0,0,0-2.191,5.29L7.5,25.012a3.1,3.1,0,0,0,5.184-2.992l.936-.936a2.325,2.325,0,0,0,3.7.679l10.793,12.4a.778.778,0,0,0,.105.131c.014.014.029.026.043.039l3.216,3.7c.08.094.165.187.254.276a4.608,4.608,0,0,0,3.275,1.362,4.755,4.755,0,0,0,.652-.045,4.688,4.688,0,0,0,3.459-2.395A4.584,4.584,0,0,0,38.966,32.55ZM15.17,2a1.549,1.549,0,0,1,2.191,0l6.574,6.574a1.549,1.549,0,0,1-2.191,2.191L15.171,4.2h0A1.551,1.551,0,0,1,15.17,2ZM10.788,23.917a1.551,1.551,0,0,1-2.192,0L2.023,17.343a1.549,1.549,0,0,1,2.19-2.192l6.575,6.575A1.551,1.551,0,0,1,10.788,23.917Zm3.262-5.453L11.884,20.63,5.309,14.056l8.765-8.765,6.574,6.574-2.17,2.17-.021.021-4.38,4.38Zm2.766,1.616,0,0-.546.546a.775.775,0,0,1-1.105-1.086l4.4-4.4a.775.775,0,0,1,1.314.557.768.768,0,0,1-.227.548l-.542.542L20.1,16.8Zm1.6.587L20.685,18.4l9.587,8.362-3.5,3.5Zm9.373,10.768,3.649-3.649,1.17,1.021-3.8,3.8Zm9.974,5.036a3.151,3.151,0,0,1-2.319,1.617,3.078,3.078,0,0,1-2.619-.878c-.06-.06-.117-.122-.17-.184l-.008-.009-2.819-3.239,3.951-3.951,3.235,2.821.007.006a3.335,3.335,0,0,1,.639.736A3.059,3.059,0,0,1,37.767,36.471Z",
    transform: "translate(0.274 0.295)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109_-_Outline",
    "data-name": "Path 10109 - Outline",
    d: "M35.059,40.009a4.893,4.893,0,0,1-3.48-1.447c-.094-.094-.185-.193-.27-.294l-3.2-3.678c-.015-.013-.029-.026-.043-.04a1.064,1.064,0,0,1-.132-.161l-10.6-12.175a2.614,2.614,0,0,1-3.422-.239A2.629,2.629,0,0,1,13.6,21.6l-.556.556a3.4,3.4,0,0,1-.915,3.107,3.393,3.393,0,0,1-4.793,0L.762,18.688A3.389,3.389,0,0,1,3.87,12.979L13,3.851A3.4,3.4,0,0,1,13.914.744a3.388,3.388,0,0,1,4.792,0L25.283,7.32a3.388,3.388,0,0,1-3.107,5.708l-.557.557a2.613,2.613,0,0,1,.614,3.734L34.318,27.86a1.058,1.058,0,0,1,.251.185,1.074,1.074,0,0,1,.111.13l3.595,3.135a5.163,5.163,0,0,1,.986,1.133,4.877,4.877,0,0,1,.162,4.977,4.976,4.976,0,0,1-3.672,2.54A5.061,5.061,0,0,1,35.059,40.009ZM17.386,21.393,28.395,34.042l.011.018a.491.491,0,0,0,.066.083l.027.024.016.014,3.231,3.712q.116.137.241.261a4.32,4.32,0,0,0,3.072,1.278,4.48,4.48,0,0,0,.613-.042,4.4,4.4,0,0,0,3.248-2.251,4.294,4.294,0,0,0-.143-4.382,4.593,4.593,0,0,0-.878-1.009l-3.653-3.186-.021-.032a.5.5,0,0,0-.062-.076.485.485,0,0,0-.132-.093l-.035-.017L21.411,17.367l.209-.218a2.032,2.032,0,0,0-.6-3.241l-.37-.175L22,12.387l.161.043a2.831,2.831,0,0,0,.727.1,2.81,2.81,0,0,0,1.988-4.8L18.3,1.152a2.811,2.811,0,0,0-3.976,0A2.824,2.824,0,0,0,13.6,3.866l.043.161L4.047,13.619l-.161-.043a2.835,2.835,0,0,0-.728-.1,2.811,2.811,0,0,0-1.988,4.8l6.576,6.576a2.815,2.815,0,0,0,3.976,0,2.824,2.824,0,0,0,.726-2.715l-.043-.161,1.342-1.342.176.368a2.037,2.037,0,0,0,3.243.6ZM35.064,38.459a3.359,3.359,0,0,1-2.389-.993c-.065-.065-.127-.133-.186-.2l0-.006-3-3.443,4.333-4.333,3.444,3a3.627,3.627,0,0,1,.7.8,3.355,3.355,0,0,1,.112,3.379,3.439,3.439,0,0,1-2.532,1.762A3.475,3.475,0,0,1,35.064,38.459Zm-4.787-4.616,2.653,3.049c.048.057.1.113.153.166a2.786,2.786,0,0,0,1.981.824,2.9,2.9,0,0,0,.4-.027,2.866,2.866,0,0,0,2.108-1.472,2.764,2.764,0,0,0-.093-2.784,3.051,3.051,0,0,0-.584-.673l-.014-.012-3.029-2.642Zm-1.429-.763-1.4-1.608,4.031-4.031,1.607,1.4ZM28.237,31.5l.64.736,3.364-3.364-.735-.641Zm-1.429-.763L18.071,20.7l2.646-2.646L30.744,26.8ZM18.86,20.727l7.976,9.163L29.9,26.828l-9.155-7.985ZM9.734,24.706a1.826,1.826,0,0,1-1.3-.538L1.858,17.592a1.838,1.838,0,0,1,2.6-2.6l6.577,6.577a1.838,1.838,0,0,1-1.3,3.137ZM3.158,15.031a1.261,1.261,0,0,0-.892,2.153L8.842,23.76a1.261,1.261,0,0,0,1.784-1.783L4.049,15.4A1.252,1.252,0,0,0,3.158,15.031Zm12.6,6.161a1.063,1.063,0,0,1-.764-1.8l4.4-4.4A1.064,1.064,0,0,1,20.9,16.5L16.515,20.88A1.057,1.057,0,0,1,15.762,21.192Zm4.384-5.933a.482.482,0,0,0-.338.136l-4.4,4.4a.476.476,0,0,0-.133.334.487.487,0,0,0,.831.345l4.384-4.384a.485.485,0,0,0-.344-.83Zm-8.22,5.826L4.942,14.1l9.176-9.176L21.1,11.908l-6.778,6.778-.019.019-.008.008ZM5.758,14.1l6.169,6.168,1.96-1.96.031-.032L18.3,13.9l.024-.023,1.964-1.964L14.118,5.74Zm17.129-2.546a1.826,1.826,0,0,1-1.3-.538L15.011,4.44a1.838,1.838,0,1,1,2.6-2.6l6.576,6.576a1.838,1.838,0,0,1-1.3,3.138ZM16.31,1.878a1.262,1.262,0,0,0-.892,2.153L22,10.608a1.261,1.261,0,1,0,1.783-1.784L17.2,2.248A1.254,1.254,0,0,0,16.31,1.878Z",
    transform: "translate(0.229 0.249)",
    fill: "#00641f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtSelling);
export default __webpack_public_path__ + "static/media/courtSelling.fcb84a370561cbbd4dead9b55b73d0bb.svg";
export { ForwardRef as ReactComponent };